import { useId, useState } from 'react';
import clsx from 'clsx';
import { ChevronRightIcon } from '@components/icons/ChevronRightIcon';

/**
 * @param {{
 *   items: { question: string; answer: string  }[];
 * }} props
 *
 * @returns JSX.Element
 */
export function Accordion({ items }) {
  const accordionId = useId();

  const [expandedQuestion, setExpandedQuestion] = useState(null);

  return (
    <ul className={clsx('list-none m-0 p-0', 'flex flex-col gap-[32px]')}>
      {items.map(({ question, answer }, idx) => {
        const controlId = `${accordionId}-control-${idx}`;
        const panelId = `${accordionId}-panel-${idx}`;

        const expanded = question === expandedQuestion;

        return (
          <li
            key={question}
            className={clsx('!m-0', 'flex flex-row gap-[8px]')}
          >
            {/* Arrow on the left */}
            <div>
              <div
                className={clsx(
                  'pt-[2px]',
                  'transition-transform duration-300',
                  expanded && 'rotate-90',
                )}
              >
                <ChevronRightIcon size={24} color="#ffffff" />
              </div>
            </div>

            {/* Content */}
            <div
              className={clsx(
                'flex-1',
                'pb-[16px]',
                'border-b border-b-wtf-white',
              )}
            >
              {/* Trigger */}
              <h3 className="m-0">
                <button
                  id={controlId}
                  className={clsx(
                    'w-full',
                    'flex flex-row items-start gap-[16px]',
                    'text-start text-[24px] whitespace-normal break-words',
                    'text-wtf-white',
                  )}
                  aria-controls={panelId}
                  aria-expanded={expanded}
                  onClick={() => {
                    setExpandedQuestion(() => {
                      if (expanded) {
                        return null;
                      }

                      return question;
                    });
                  }}
                >
                  {question}
                </button>
              </h3>

              {/* Panel */}
              <div
                id={panelId}
                aria-labelledby={controlId}
                aria-hidden={!expanded}
                className={clsx(
                  expanded ? 'pt-[16px]' : 'py-0',
                  expanded ? 'leading-normal' : 'leading-[0]',
                  expanded ? 'opacity-100' : 'opacity-0',
                  'transition-all duration-300',
                  'text-[18px] text-wtf-silver',
                )}
              >
                <p
                  className={clsx(
                    'm-0',
                    'text-inherit leading-[inherit]',
                    'overflow-hidden',
                  )}
                >
                  {answer}
                </p>
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
